export enum MoveType {
  Great = 1,
  Best = 2,
  Excellent = 3,
  Good = 4,
  Book = 5,
  Inaccuracy = 6,
  Mistake = 7,
  Miss = 8,
  Blunder = 9,
  Brilliant = 10,
}
